import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VLayout,
    { attrs: { column: "" } },
    [
      _c(
        VFlex,
        { attrs: { "mt-3": "" } },
        [
          _c(
            VCard,
            { staticClass: "pa-3" },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c("attribute-filter-panel", {
                        attrs: {
                          "filter-rules":
                            _vm.architectureRulesLinePricingFilter,
                          "title-localisation":
                            "attributes.filters.filterByAttributes",
                          "filter-count-localisation":
                            "attributes.filters.numApplied",
                          "fixed-filter-rules": _vm.fixedFilterRules,
                          "enable-store-group-chain-filter": false,
                        },
                        on: { attributeFilterChange: _vm.setAttributeFilter },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center mb-2" },
                [
                  !_vm.isChainsModeEnabled
                    ? _c("norm-weight-toggle", {
                        staticClass: "mr-2 d-inline-flex",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("line-pricing-import-button", {
                    attrs: { disabled: _vm.isLoading },
                    on: { click: _vm.handleImportClick },
                  }),
                  _vm._v(" "),
                  _c("span", [_c("line-pricing-export-button")], 1),
                  _vm._v(" "),
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center filter-buttons-container",
                    },
                    [
                      _c("span", { staticClass: "filter-by-text mr-2" }, [
                        _vm._v(_vm._s(_vm.$t("inputs.filterBy"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          staticClass: "columns-toggle grid-btn pa-0 mr-2",
                          attrs: { secondary: "", small: "", depressed: "" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSideBar("columns")
                            },
                          },
                        },
                        [
                          _c(VIcon, { staticClass: "mr-1" }, [
                            _vm._v("mdi-view-column-outline"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("inputs.columns")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          staticClass: "filters-toggle grid-btn pa-0",
                          attrs: { secondary: "", small: "", depressed: "" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSideBar("filters")
                            },
                          },
                        },
                        [
                          _c(VIcon, { staticClass: "mr-1" }, [
                            _vm._v("mdi-filter-outline"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("inputs.filters")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ag-grid-box" },
                [
                  _c("ag-grid-vue", {
                    staticClass: "ag-theme-custom ag-theme-custom-stripped",
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "default-col-def": _vm.defaultColDef,
                      "suppress-row-click-selection": true,
                      "stop-editing-when-cells-lose-focus": true,
                      "fill-operation": _vm.fillOperation,
                      "side-bar": _vm.sideBar,
                    },
                    on: {
                      "grid-ready": _vm.onGridReady,
                      "first-data-rendered": _vm.onFirstDataRendered,
                      "cell-value-changed": _vm.onCellValueChanged,
                      "column-visible": _vm.onColumnStateChanged,
                      "column-pinned": _vm.onColumnStateChanged,
                      "column-moved": _vm.onColumnStateChanged,
                      "column-resized": _vm.onColumnStateChanged,
                      "sort-changed": _vm.onColumnStateChanged,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3 text-right" },
                [
                  _vm.hasInvalidLinePricingAssignments && !_vm.isLoading
                    ? _c(
                        VAlert,
                        {
                          staticClass: "mr-3 d-inline-flex mb-0 alert-message",
                          attrs: {
                            color: "error",
                            icon: false,
                            dense: "",
                            outlined: "",
                            elevation: "0",
                            role: "alert",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "settings.architecture.differentSubGroupValidationError"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "grid-btn mr-2",
                      attrs: {
                        secondary: "",
                        small: "",
                        disabled: !Object.keys(_vm.dirtyRowsByKey).length,
                        depressed: "",
                      },
                      on: { click: _vm.onDiscard },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("inputs.cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: "success",
                        small: "",
                        disabled: _vm.isSaveDisabled,
                        loading: _vm.isSaving,
                        depressed: "",
                      },
                      on: { click: _vm.onSave },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.save")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("line-pricing-groups-upload-data", {
        attrs: {
          "show-dialog": _vm.showLPGUpload,
          params: {
            architectureGroupId: _vm.importByArchitectureGroup
              ? _vm.architectureGroupId
              : null,
          },
        },
        on: {
          closeDialog: function ($event) {
            _vm.showLPGUpload = false
          },
        },
      }),
      _vm._v(" "),
      _c("line-pricing-group-dialog", {
        attrs: {
          mode: _vm.lpgDialogMode,
          groups: _vm.linePricingGroupOptions,
          submitting: _vm.lpgDialogSubmitting,
          success: _vm.lpgDialogSuccess,
        },
        on: {
          create: _vm.onDialogCreate,
          edit: _vm.onDialogEdit,
          delete: _vm.onDialogDelete,
          cancel: _vm.onCloseLpgDialog,
          dismiss: _vm.onDismissLpgDialog,
        },
        model: {
          value: _vm.showLpgDialog,
          callback: function ($$v) {
            _vm.showLpgDialog = $$v
          },
          expression: "showLpgDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }